import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUnitByUserPermission } from '../../api/unitByUserPermission';

const initialUnitByUserPermissionSlice: IUnitByUserPermission[] = []

const unitByUserPermissionSlice = createSlice({
  name: 'unitByUserPermissionSlice',
  initialState: initialUnitByUserPermissionSlice,
  reducers: {
    setUnitByUserPermission: (state, action: PayloadAction<IUnitByUserPermission[]>) => action.payload,
    clearUnitByUserPermission: (state) => initialUnitByUserPermissionSlice
  }
})

export const selectorUnitByUserPermission = (state: { unitByUserPermissionSlice: IUnitByUserPermission[] }) => state.unitByUserPermissionSlice;
export const { setUnitByUserPermission, clearUnitByUserPermission } = unitByUserPermissionSlice.actions;
export default unitByUserPermissionSlice.reducer;
